export default "__VITE_ASSET__k8VeZGUP__"